module.exports = __webpack_public_path__ + "assets/a57d06def1925bba44ecde8e3ecff3bf.png";